function omitKeysFromObject(obj, ...omitKeys) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (!omitKeys.includes(key)) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export { omitKeysFromObject };
